import { useEffect, useState } from "react";

export function useIsOnViewport(ref: React.RefObject<HTMLElement | null>) {
	const [isOnViewport, setIsOnViewport] = useState(false);

	useEffect(() => {
		if (!window.IntersectionObserver) {
			console.warn("IntersectionObserver is not supported in this browser");
			return;
		}

		const observer = new IntersectionObserver(
			([entry]) => {
				setIsOnViewport(entry.isIntersecting);
			},
			{
				root: null,
				rootMargin: "0px",
				threshold: 0.1,
			},
		);

		const currentElement = ref.current;

		if (currentElement) {
			observer.observe(currentElement);
		}

		return () => {
			if (currentElement) {
				observer.unobserve(currentElement);
			}
		};
	}, [ref]);

	return { isOnViewport };
}
